import CasesSearchInput from "./CasesSearchInput";
export default CasesSearchInput;
